export default __webpack_public_path__ + "static/media/pack-event-special.fe103960.png";